import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import PatientsTable from "../tables/PatientsTable";
import { RiCalendar2Fill } from "react-icons/ri";
import { AiOutlinePlus } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { get } from "../../utility/fetch";
import TagInputs from "../layouts/TagInputs";
// import ReferralModal from "../modals/RefferalModal";
import Spinner from "../UI/Spinner";
import { usePatient } from "../../contexts";
import Pagination from "../layouts/Pagination";
import ClientList from "../layouts/ClientList";
import WalkInModal from "../modals/WalkInModal";
import WalkInTable from "../layouts/WalkInTable";
import Personal from "./Patient/Personal";
import QueuedWalkInTable from "../tables/QueuedWalkInTable";
// import VitalPatientsTable from "../tables/VitalPatientTable";
// import AdmitCheck from "./Patient/AdmitCheck";
// import PatientsAppointTable from "../tables/PatientsAppointTable";

function PatientQueue() {
  const [allPatients, setAllPatients] = useState([]);
  const [vitalPatients, setVitalPatients] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [payload, setPayload] = useState('');
  const [filterSelected, setFilterSelected] = useState("firstName");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [queuedloading, setQueuedLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPagesVital, setTotalPagesVital] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [admittedPatients, setAdmittedPatients] = useState([])
  const [appointPatients, setAppointPatients] = useState([])
  const [allPending, setAllPending] = useState([])
  const [checkinPatients, setCheckinPatients] = useState(false)
  const [nurseTypes, setNurseTypes] = useState('admin');
  const [selectedTab, setSelectedTab] = useState('queue');
  const [allWalkIn, setAllWalkIn] = useState([]);




  const itemsPerPage = 10;

  const { setHmoDetails, patientId, nurseRoles } = usePatient();

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
      getWalkInPatients(newPage);
    }
  };

  const generatePageNumbers = (currentPage, totalPages) => {
    let pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages = [1, 2, 3, 4, totalPages];
      } else if (currentPage >= totalPages - 2) {
        pages = [1, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
      } else {
        pages = [1, currentPage - 1, currentPage, currentPage + 1, totalPages];
      }
    }
    return pages;
  };

  const closeModal = () => {
    getAllPatients();
    setIsModalOpen(false);
  };

  const selectRecord = () => () => {
    setIsModalOpen(true);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  let navigate = useNavigate();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };


  const renderTabContent = (selectedTab) => {
    switch (selectedTab) {
      case "walkin":
        return <WalkInTable data={allPatients} loading={loading} currentPage={currentPage} itemsPerPage={itemsPerPage} />;
      case "queue":
        return <QueuedWalkInTable  isQueue={true} loading={queuedloading} getProcedures={getWalkInPatients} data={allWalkIn} readOnly={false} />
      default:
        return <Personal setSelectedTab={setSelectedTab} renderTabContent={renderTabContent} />;
    }
  };

  const CustomInput = ({ value, onClick }) => (
    <button
      onClick={onClick}
      onKeyDown={(e) => e.preventDefault()}
      className="custom-datepicker-input flex gap-6 flex-v-center"
    >
      {isToday(selectedDate) ? "Today" : formatDate(selectedDate)}
      <RiCalendar2Fill />
    </button>
  );

  const getAllAdmittedPatients = async (currentPage) => {
    setLoading(true);
    try {
      let res = await get(`/patients/admitted-patients?pageNumber=${currentPage}&pageSize=10`);
      setAdmittedPatients(res?.data);
      setTotalPages(res?.pageCount);
    } catch (error) {
      console.error('Error fetching all patients:', error);
    } finally {
      setLoading(false);
    }
  };

  const getAllPatients = async () => {
    setLoading(true);
    try {
      let res = await get(`/walkinlabrequest/list`);
      console.log(res)
      setAllPatients(res?.data);
      setTotalPages(res?.data?.length % 10);
    } catch (error) {
      console.error('Error fetching all patients:', error);
    } finally {
      setLoading(false);
    }
  };

  const getAllPending = async () => {
    setLoading(true);
    try {
      let res = await get(`/walkinlabrequest/list/${currentPage}/${itemsPerPage}`);
      console.log(res)
      setAllPending(res?.data?.recordList);
      setTotalPages(res?.data?.metadata?.totalPages);
    } catch (error) {
      console.error('Error fetching all pending patients:', error);
    } finally {
      setLoading(false);
    }
  };

  const getAppointmentPatients = async () => {
    setLoading(true);
    try {
      let res = await get(`/Appointment/get-pending-appointments?pageIndex=${currentPage}&pageSize=${itemsPerPage}`);
      setAppointPatients(res?.data);
      setTotalPages(res?.pageCount);
    } catch (error) {
      console.error('Error fetching all patients:', error);
    } finally {
      setLoading(false);
    }
  };

  const getPatientsAwaitingVital = async (searchParam) => {
    setLoading(true);
    try {
      let url = '/patients/patient-awaiting-vital?'
      if (searchParam) {
        url += `pageIndex=${currentPage}&pageSize=${itemsPerPage}&AppointmentDate=${searchParam}`
      } else {
        url += `pageIndex=${currentPage}&pageSize=${itemsPerPage}`;
      }

      let res = await get(url);
      setVitalPatients(res?.data);
      setTotalPagesVital(res?.pageCount);
    } catch (error) {
      console.error('Error fetching all patients:', error);
    } finally {
      setLoading(false);
    }
  };

  const searchPatients = async (searchParam) => {
    setLoading(true);
    try {
      let url = '/patients/filter?';
      if (filterSelected) {
        url += `${filterSelected}=${searchParam}&`;
      }
      url += `pageIndex=1&pageSize=100`;
      let res = await get(url);
      setAllPatients(res?.data);
    } catch (error) {
      console.error('Error fetching all patients:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "filter") {
      setFilterSelected(value);
    } else if (name === 'searchDate') {
      const formattedDate = formatDate(value);
      setSearchTerm(value)
    } else {
      setPayload(value);
    }
  };

  useEffect(() => {
    if (nurseTypes === ('admit')) {
      getAllAdmittedPatients(currentPage);
    } else if (nurseTypes === ('vital')) {
      getPatientsAwaitingVital(searchTerm);
    } else if (nurseTypes === ('checkin') && checkinPatients === true) {
      getAppointmentPatients(currentPage);
    } else {
      getAllPatients(currentPage);
    }


    getWalkInPatients(currentPage);
  }, [searchTerm, nurseTypes, checkinPatients]);

  useEffect(() => {
    if (payload) {
      searchPatients(payload);
    } else {
      getAllPatients();
    }
  }, [filterSelected, payload]);

  const filterOptions = [
    { value: "firstName", name: "First Name" },
    { value: "lastName", name: "Last Name" },
    { value: "email", name: "Email" },
    { value: "phoneNumber", name: "Phone Number" },
    { value: "patientRef", name: "Lab Id" },
  ];


  const getWalkInPatients = async (page) => {
    setQueuedLoading(true);
    let res = await get(`/walkinlabrequest/list/true/UnPaid?pageNumber=${page}&pageSize=${itemsPerPage}`)

    if (res?.statusCode === 200) {
      // notification({ message: res?.data?.message, type: "success" });
      setAllWalkIn(res.data?.recordList);
      setTotalPages(res?.data?.metadata?.totalPages);
      console.log(res)
      setQueuedLoading(false);
    }
    else {
      // console.error('Error fetching all patients:', res?.data?.message);
      setQueuedLoading(false);
      // notification({ message: res?.data?.message, type: "error" });
    }
  }


  return (
    <div className="w-100 m-t-40">
      {(
        <>
          <h1 className="m-t-20">Walk-In Patients</h1>
        

          <div className="flex flex-v-center flex-h-end gap-8 ">
            {/* <div className=""> */}
            {/* <TagInputs onChange={handleChange} name="firstName" label="Find Patient" /> */}
            {/* </div> */}
            {/* <div className="flex flex-v-center "> */}
            {/* <TagInputs
              onChange={handleChange}
              name="filter"
              type="select"
              options={filterOptions}
            /> */}
            {/* </div> */}
            {/* <div className="   m-t-10">
              <button onClick={() => { setIsModalOpen(true); }} className="btn no-wrap flex flex-h-center gap-10 flex-v-center">
                <>
                  <AiOutlinePlus size={24} color="white" />
                  <p className=" m-r-10 no-wrap">Check in a Patient</p>
                </>
              </button>
            </div> */}

          </div>

          {/* <WalkInTable data={allPatients} currentPage={currentPage} itemsPerPage={itemsPerPage} />
             */}

          <div>
            {renderTabContent(selectedTab)}
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            generatePageNumbers={generatePageNumbers}
          />
        </>

      )}

      {isModalOpen &&
        <WalkInModal
          closeModal={closeModal}
          approveComponent={true}
        />
      }
    </div>

  );
}

export default PatientQueue;
